import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi, putApi } from "../CreateApi";
import {
  responseGetAllUsers,
  responseGetUsetId,
  ResponseNewUser,
  responseNewUser,
  UserFull,
} from "./interfaceStaff";
import { FilteredDebTor } from "../student/interfaceUser";

export const getAllUser = async (params: any): Promise<ResponseNewUser> => {
  try {
    const data = await getApi("/user/search", params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseNewUser;
  }
};

export const getAllUserRol = async (params: any): Promise<ResponseNewUser> => {
  try {
    const data = await getApi("/user", params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseNewUser;
  }
};

export const postNewUser = async (body: any): Promise<any> => {
  try {
    const data = await postApi("/user", body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const patchUser = async (
  body: any,
  id?: number,
): Promise<responseNewUser> => {
  try {
    const data = await patchApi(`/user/${id}`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseNewUser;
  }
};

export const patchAsssignRol = async (
  body: any,
  sub?: string,
): Promise<responseNewUser> => {
  try {
    const data = await patchApi(`/user/assign-role/${sub}`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseNewUser;
  }
};

export const getAllUserId = async (id?: number): Promise<responseGetUsetId> => {
  try {
    const data = await getApi(`/user/${id}`);

    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseGetUsetId;
  }
};

export const deleteUserId = async (term: number): Promise<any> => {
  try {
    const data = await deleteApi(`/user/${term}`, term);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const activeAllUser = async (
  activityClassroomId: number,
): Promise<FilteredDebTor[]> => {
  try {
    const data = await getApi(
      `/user/activity-classroom/${activityClassroomId}`,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getAllRolsUser = async (term: string): Promise<any> => {
  try {
    const data = await getApi(`/user/${term}/roles`);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const deleteRolUser = async (
  sub: string,
  term: { roleName: string },
): Promise<any> => {
  try {
    const data = await deleteApi(`/user/${sub}/roles`, term);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getUserFull = async (id: number): Promise<UserFull> => {
  try {
    const data = await getApi(`/user/${id}/full`);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as UserFull;
  }
};

export const putUserRoles = async (
  sub: string,
  body: { roleNames: string[] },
): Promise<any> => {
  try {
    const data = await putApi(`/user/${sub}/roles`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const putUserAssignmentClassroom = async (
  id: number,
  body: { activityClassroomIds: number[] },
): Promise<any> => {
  try {
    const data = await putApi(`/user/${id}/assignment-classroom`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};
